import React from 'react';
import { motion } from 'framer-motion';
export function Bonus() {
  return <section id="bonus" className="py-20 px-4 bg-gradient-to-br from-brand-purple to-brand-dark text-white relative overflow-hidden scroll-mt-16" data-id="element-17">
      {/* Confetti/Stars */}
      <div className="absolute top-10 left-10 text-3xl animate-wiggle" data-id="element-18">⭐</div>
      <div className="absolute bottom-10 right-10 text-4xl animate-wiggle" style={{
      animationDelay: '0.5s'
    }} data-id="element-19">
        🎮
      </div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-20">
        <motion.div initial={{
        scale: 0.9,
        opacity: 0
      }} whileInView={{
        scale: 1,
        opacity: 1
      }} viewport={{
        once: true
      }} className="bg-white/10 backdrop-blur-md border border-white/20 p-8 md:p-12 rounded-[3rem]" data-id="element-21">
          <div className="inline-block bg-brand-pink text-white font-bold px-6 py-2 rounded-full mb-6 text-lg uppercase tracking-wider transform rotate-2" data-id="element-22">
            ¡Bonus Gratuito! 🎁
          </div>

          <h2 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-23">
            Acceso a MiniMundo
          </h2>

          <p className="text-xl md:text-2xl mb-8 text-pastel-mint font-medium" data-id="element-24">
            Plataforma de juegos educativos gratis para niños de 2 a 7 años.
          </p>

          <p className="text-lg text-gray-300 mb-10 max-w-2xl mx-auto" data-id="element-25">
            Al comprar la guía hoy, te llevas acceso directo a nuestra
            plataforma web llena de minijuegos interactivos diseñados para
            reforzar lo aprendido.
          </p>

          {/* MiniMundo se incluye gratis con la guía — solo informativo, no redirige */}
          <div className="inline-flex items-center gap-3 bg-pastel-yellow/20 border border-pastel-yellow/40 text-pastel-yellow font-display font-bold text-lg py-3 px-6 rounded-full mb-8" data-id="element-26">
            <span className="text-2xl" data-id="element-27">🎮</span>
            <span data-id="element-28">MiniMundo incluido GRATIS con tu guía</span>
          </div>

          <div className="flex justify-center" data-id="element-29">
            <motion.a href="#comprar" whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} className="inline-flex items-center gap-3 bg-brand-pink text-white font-display font-bold text-xl py-4 px-8 rounded-full shadow-[0_6px_0_#be185d] hover:shadow-[0_4px_0_#be185d] hover:translate-y-[2px] transition-all" data-id="element-30">
              <span data-id="element-31">Quiero mi guía por $17</span>
              <span className="text-2xl" data-id="element-32">🎉</span>
            </motion.a>
          </div>
        </motion.div>
      </div>
    </section>;
}